<script lang="ts">
	import queryString from "query-string";
	import Form from "../layouts/Form.svelte";
	import NewResultLayout from "../layouts/NewResultLayout.svelte";
	import AppLayout from "../layouts/AppLayout.svelte";
	import { t, api } from "@hitit/hub/src/stores";
	import {
		DefaultDone,
		FormInputComposite,
		DefaultButton,
		InputFrame,
	} from "@hitit/new_ui/src";
	import { navigate } from "svelte-routing";

	let loading = false;
	let success = false;

	let name = "";
	let password = "";
	let confirmPassword = "";

	let passwordErrorMessage = "";
	let confirmPasswordErrorMessage = "";
	let networkErrorMessage = "";

	$: disabledCondition = password === "" || confirmPassword === "" || loading;

	const parsed = queryString.parse(location.search);
	const token = parsed["token"] as string;
	const username = parsed["userId"] as string;

	if (!(token && username)) location.replace("/");

	async function submitHandler(e: Event) {
		e.preventDefault();
		networkErrorMessage = "";
		passwordErrorMessage = !/^[a-zA-Z\d@$!*#?&]*$/.test(password)
			? $t("sso.error.noCorrectPasswordFormat")
			: password.length < 8
			? $t("sso.error.passwordLength")
			: "";

		confirmPasswordErrorMessage =
			password !== confirmPassword ? $t("sso.error.notMatchPassword") : "";

		if (passwordErrorMessage || confirmPasswordErrorMessage) return;
		try {
			loading = true;
			await $api.resetPassword(token, username, name, password);
			success = true;
		} catch {
			networkErrorMessage = $t("sso.error.unknownError");
		} finally {
			loading = false;
		}
	}
</script>

<AppLayout>
	{#if success}
		<NewResultLayout text={username}>
			<div class="done-box" slot="result-icon">
				<DefaultDone />
			</div>
			<p class="result">{$t("sso.reset_password.change_success")}</p>
			<div class="result-buttons">
				<empty />
				<DefaultButton on:click={() => navigate("/")}>
					<span class="white">LOGIN</span>
				</DefaultButton>
			</div>
		</NewResultLayout>
	{:else}
		<Form clearMode on:submit={submitHandler}>
			<InputFrame gap={20} direction={"column"}>
				<FormInputComposite
					password
					on:input={() => {
						passwordErrorMessage = "";
					}}
					labelFor={"password"}
					inputName={$t("sso.password")}
					error={passwordErrorMessage !== ""}
					errorMessage={passwordErrorMessage}
					placeholder={$t("sso.signup.8_or_more")}
					clearButtonCallback={() => {
						password = "";
					}}
					bind:value={password}
				/>
				<FormInputComposite
					password
					labelFor={"confirmPassword"}
					on:input={() => {
						confirmPasswordErrorMessage = "";
					}}
					placeholder={$t("sso.signup.8_or_more")}
					error={confirmPasswordErrorMessage !== ""}
					errorMessage={confirmPasswordErrorMessage}
					clearButtonCallback={() => {
						confirmPassword = "";
					}}
					inputName={$t("sso.confirm_password")}
					bind:value={confirmPassword}
				/>
			</InputFrame>
			<p class="error">{networkErrorMessage}</p>
			<DefaultButton isLoading={loading} disabled={disabledCondition}>
				<span class="white" class:disabled={disabledCondition}
					>{$t("sso.reset_password.change_password")}</span
				>
			</DefaultButton>
		</Form>
	{/if}
</AppLayout>

<style lang="scss">
	p {
		&.result {
			margin-top: 10px;
			font-size: 1.125rem;
			color: white;
		}
		&.error {
			box-sizing: border-box;
			padding: 10px;
			height: 50px;
			color: var(--error-color-1);
		}
	}
	.result-buttons {
		display: flex;
		flex-direction: column;
		align-items: center;
		max-width: 400px;
		width: 100%;
		flex-grow: 1;
		max-height: 129px;
	}
	.done-box {
		width: 121px;
		height: 115.2px;
	}
	span {
		&.white {
			color: white;

			&.disabled {
				color: var(--default-disabled-btn-2);
			}
		}
	}

	empty {
		display: block;
		width: 100%;
		height: 109px;
	}
</style>
